import { render, staticRenderFns } from "./AssignSettings.vue?vue&type=template&id=127ed0e5&scoped=true&"
import script from "./AssignSettings.vue?vue&type=script&lang=ts&"
export * from "./AssignSettings.vue?vue&type=script&lang=ts&"
import style0 from "./AssignSettings.vue?vue&type=style&index=0&id=127ed0e5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "127ed0e5",
  null
  
)

export default component.exports